/* v8 ignore start */
// extracted to avoid circular dependencies

export const enum Fit {
  Contain = "contain", // The entire image will be visible, but this might leave empty space in the container if the aspect ratios differ.
  Cover = "cover", // Scales the image to maintain its aspect ratio while filling the container's entire content. Parts of the image may be clipped if the aspect ratios differ.
}

// TODO: Consider adding panTowards
export const enum Effect {
  ZoomInCenter = "zoomInCenter",
  ZoomInTowardsFocusPoint = "zoomInTowardsFocusPoint",
  ZoomOutFromFocusPoint = "zoomOutFromFocusPoint",
  ZoomInTowardsSalientBox = "zoomInTowardsSalientBox",
  ZoomOutFromSalientBox = "zoomInFromSalientBox",
  ZoomOutCenter = "zoomOutCenter",
  PanLeft = "panLeft",
  PanRight = "panRight",
  PanTowardsFocusPoint = "panTowardsFocusPoint",
  PanDown = "panDown",
  PanUp = "panUp",
}
/* v8 ignore stop */
